import React from 'react';
import { TERRAIN } from '../content';
import { SCENE_IMG } from '../media';

/* One contained card over the photograph: the headline sits under the storm
   clouds, the range shows through the middle, and the four challenges sit on
   the darkened ground. The card keeps the page's standard section rhythm. */
export function Terrain() {
  return <section className="border-t border-border bg-card" aria-labelledby="terrain-heading" data-id="element-104" data-mp="32z4w3oim3e35">
      <div className="section-shell py-16 lg:py-20" data-id="element-105" data-mp="36ydpgs9qp9y6">
        <div className="relative overflow-hidden rounded-lg text-cream" data-id="element-106" data-mp="3bx710f5guqvp">
          <img src={SCENE_IMG.terrainRange} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_60%]" data-id="element-107" data-mp="3gwtgywcoil87" />
          {/* Darker at the top for the headline and at the bottom for the
              list; lighter through the middle so the peaks read. */}
          <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(180deg, rgba(12,10,9,0.62) 0%, rgba(12,10,9,0.28) 42%, rgba(12,10,9,0.5) 62%, rgba(12,10,9,0.86) 100%)'
        }} data-id="element-108" data-mp="1rhd87i2o31iu" />

          <div className="relative px-6 pb-10 pt-10 sm:px-10 lg:px-12 lg:pb-12 lg:pt-12" data-id="element-109" data-mp="32lhzx5vu1rah">
            <p className="overline" style={{
            color: 'rgba(252,250,244,0.8)'
          }} data-id="element-110" data-mp="2xm5bwht86e6b">
              The terrain
            </p>
            <h2 id="terrain-heading" className="mt-5 max-w-2xl font-serif text-h3 lg:text-h2" data-id="element-111" data-mp="3qcng5m5oqllb">
              The climb is hard. You shouldn&rsquo;t make it alone.
            </h2>

            <ol className="mt-40 grid gap-8 sm:grid-cols-2 lg:mt-56 lg:grid-cols-4 lg:gap-10" data-id="element-112" data-mp="3lbzr3610oetq">
              {TERRAIN.map((item, i) => <li key={item.title} className="border-t border-[rgba(252,250,244,0.35)] pt-5" data-id="element-113" data-mp="3cdw3832k75yr" data-mpi={i}>
                  <span className="text-body-sm text-[var(--brand-gold-lifted)]" data-id="element-114" data-mp="24zt1bkbztrj8">0{i + 1}</span>
                  <h3 className="mt-3 font-serif text-h4 leading-snug" data-id="element-115" data-mp="20xfueslifnkv">{item.title}</h3>
                  <p className="mt-2 text-body-sm leading-body text-[rgba(252,250,244,0.88)]" data-id="element-116" data-mp="22febwwd6xnfv">
                    {item.body}
                  </p>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}